import { render, staticRenderFns } from "./CaseDashboardCard.vue?vue&type=template&id=eb2439d0&scoped=true&"
import script from "./CaseDashboardCard.vue?vue&type=script&lang=ts&"
export * from "./CaseDashboardCard.vue?vue&type=script&lang=ts&"
import style0 from "./CaseDashboardCard.vue?vue&type=style&index=0&id=eb2439d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2439d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VImg,VTooltip})
